import { useTranslation } from "react-i18next";
import { IconHomeLine, IconPlus } from "@pentabd/icons";
import { Button, Header } from "@pentabd/ui";
import { Link } from "react-router-dom";
import { ROUTES } from "@constants/routes";

export default function ProcurementDemandListHeader() {
  const { t } = useTranslation();
  const breadcrumbs = [
    {
      icon: <IconHomeLine fill="dark" size="20" />,
    },
    {
      label: t("SIDEBAR.PROCUREMENT.PROCUREMENT_DEMAND"),
    },
  ];

  const headerText = {
    header: t("PROCUREMENT_DEMAND.DEMAND_LIST.HEADING"),
    subHeader: t("PROCUREMENT_DEMAND.DEMAND_LIST.DESCRIPTION"),
  };

  return (
    <Header
      headerText={headerText}
      breadcrumbs={breadcrumbs}
      actions={[
        <Link to={`${ROUTES.CREATE}`}>
          <Button fill="fill" type="primary" size="xs">
            <IconPlus fill="light" size="17" />{" "}
            {t("PROCUREMENT_DEMAND.DEMAND_LIST.ADD_NEW_BUTTON")}
          </Button>
        </Link>,
      ]}
    />
  );
}
